export default __webpack_public_path__ + "static/media/dollar.d730bb48.svg";